import { formatSelectGroupData, deepClone, getGlobalSearchData } from '@/utils/utils.js';
import { mapGetters } from 'vuex';

const Student = {
  data() {
    return {
      ds: { create_person: {}, country: [] },
      visitDialogTitle: '',
      visitType: '',
      visitData: {},
      visitVisible: false, // 是否显示回访表单模态窗口
      bindVisible: false, // 是否显示绑定已有被介绍人窗口
      increaseType: '',
      editData: {},
      userOperateVisit: '', // 是否是用户运营回访
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'imUrl']),
    /**
     * 考培只读
     */
    readOnlyTraining() {
      if (this.$hasPermission(1)) {
        return false;
      }
      let userArr = [];
      if (userArr.indexOf(this.userInfo.userid) > -1) {
        return true;
      }
      return this.$hasPermission([81, 84]);
    },
    /**
     *  是否可以进行检索
     */
    canSearch() {
      if (!this.searchData) {
        return false;
      }
      return Object.values(this.searchData).some((value) => {
        if (value === null) {
          return false;
        }

        if (typeof value === 'string' && value !== '') {
          return true;
        }

        if (Array.isArray(value)) {
          return value.length && value[0];
        }

        if (value === true) {
          return true;
        }

        if (typeof value === 'object') {
          let temp = Object.values(value);
          return temp.length && temp.some((v) => {
            if (Number.isInteger(v) && v === 0) {
              return true;
            }
            return v;
          });
        }

        if (value) {
          return true;
        }
        return false;
      });
    },

    /**
     * 全部意向国家
     */
    hopeCountries() {
      let countriesCache = this.$lockr.get('countries');
      if (countriesCache && countriesCache.length > 0) {
        return countriesCache;
      }
      this.$lockr.set('countries', this.ds.country);
      return this.ds.country;
    },
    /**
     * 英美国家
     */
    countryCode() {
      return [
        30,
        31,
        673,
        674,
        471,
        486,
        2094 // 马来西亚
      ];
    },
    /**
     * 欧亚国家+韩国+日本
     */
    countryCode1() {
      return [
        672,
        1831,
        1867,
        1869,
        1870,
        1871,
        1872,
        1873,
        1874,
        1875,
        1876,
        1877,
        1878,
        1879,
        1881,
        1839,
        1770,
        83,
        2061
      ];
    },
    /**
     * 星耀东大
     */
    countryCode2() {
      return [
        2069,
        2130
      ];
    },
    loadingDs() {
      return !this.ds.create_person || !this.ds.create_person.ZZ;
    }
  },
  methods: {
    /**
     * 根据用户id获取touserid
     * @param {Number} userId
     * @param {String} type
     */
    getToUserIdByUserId(userId, type) {
      if (!this.ds[type]) {
        return false;
      }
      let touserid = null;
      Object.values(this.ds[type]).forEach((value) => {
        value.forEach((item) => {
          if (item.userid === userId) {
            touserid = item.touserid;
          }
        });
      });
      return touserid;
    },
    /**
     * 初始化数据
     */
    getDatasource() {
      return new Promise((resolve) => {
        getGlobalSearchData().then((data) => {
          this.ds = data;
          this.$store.commit('setSuperDict', data);
          // 咨询老师
          if (this.isEdit) {
            this.ds.advisory_teacher.unshift({
              first_char: '0',
              userid: -1,
              truename: '自动分配'
            });

            this.ds.training_teacher.unshift({
              first_char: '0',
              userid: -1,
              truename: '自动分配'
            });
          } else {
            this.ds.advisory_teacher.unshift({
              first_char: '0',
              userid: -2,
              truename: '未分配'
            });
            this.ds.op_teacher.unshift({
              first_char: '0',
              userid: 0,
              truename: '未分配'
            });
          }
          // 咨询
          this.ds.originAdvisoryTeacher = formatSelectGroupData(deepClone(this.ds.advisory_teacher));
          this.ds.advisory_teacher = this.formatTeacher(this.ds.advisory_teacher);
          // 文案
          this.ds.write_teacher = this.formatTeacher(this.ds.write_teacher);
          // 客服
          this.ds.cse_teacher = this.formatTeacher(this.ds.cse_teacher);
          // 文书
          this.ds.originDocumentTeacher = formatSelectGroupData(deepClone(this.ds.document_teacher));
          this.ds.document_teacher = this.formatTeacher(this.ds.document_teacher);
          // 规划
          this.ds.planning_teacher = this.formatTeacher(this.ds.planning_teacher);
          // 考培
          this.ds.originTrainingTeacher = deepClone(this.ds.training_teacher);
          this.ds.training_teacher = this.formatTeacher(this.ds.training_teacher);
          this.ds.op_teacher = this.formatTeacher(this.ds.op_teacher);
          this.ds.jw_teacher = this.formatTeacher(this.ds.jw_teacher);
          this.ds.js_teacher = this.formatTeacher(this.ds.js_teacher);
          // 客户经理
          this.ds.manager_teacher = this.formatTeacher(this.ds.manager_teacher);
          // 创建人
          this.ds.origin_create_person = deepClone(this.ds.create_person);
          this.ds.create_person = formatSelectGroupData(this.ds.create_person);
          // console.log(Object.keys(this.ds.create_person));
          return resolve(data);
          // return Promise.resolve(this.ds);
        });
      });
    },
    /**
     * 格式化教师信息 用于根据首字母分组
     */
    formatTeacher(teacher = []) {
      return formatSelectGroupData(teacher);
    },
    /**
     * 预约 and 预约回访
     */
    visitHandle(data, type, title, increase, userOperateVisit) {
      this.visitData = data;
      this.visitVisible = true;
      this.visitType = type;
      this.visitDialogTitle = title;
      this.increaseType = increase;
      this.userOperateVisit = userOperateVisit;
    },
    /**
     * 学生列表删除
     */
    handleDelete(rows) {
      this.$confirm('此操作将删除此条信息，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http._post({
          url: `/index/Student/del?id=${rows.crmid}`
        }).then(({ result }) => {
          if (result !== -1) {
            this.$message.success('删除成功');
            this.$store.commit('updateRefresh', true);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    /**
     * 放弃
     */
    handleGiveUp(rows) {
      this.$confirm('此操作将放弃该资源，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http._post({
          url: '/index/student/save',
          data: {
            id: rows.row.id,
            crm_level_lv: 66
          }
        }).then(({ result }) => {
          if (result !== -1) {
            this.$message.success('资源放弃成功');
            this.$store.commit('updateRefresh', true);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消放弃该资源',
        });
      });
    },

    /**
     * 判断当前用户咨询是不是登录咨询
     */
    isMasterTrainingTeacher(trainingTeacher) {
      if (this.$hasPermission([1]) || this.isNew) {
        return false;
      }
      return (this.$hasPermission([80, 137]) && this.userInfo.userid !== trainingTeacher);
    },

    /**
     * 验证手机号码
     * @param {String} mobile
     */
    checkMobile(mobile) {
      return /^\+?\d+$/.test(mobile);
    },
    /**
     * 只读，并且没联系信息
     */
    readOnlyNoContactInfo() {

    },

    /**
     * 检测渠道是否填写
     * @param {Object} channels
     * @returns {Boolean}
     */
    hasChannel(channels) {
      return Object.values(channels).some((item) => {
        return item;
      });
    },

    /**
     *
     * @param {Object} info
     * @returns {Boolean}
     */
    hasContactInfo(...infos) {
      return infos.some((item) => {
        return item;
      });
    },
    hasTargetCountry(targetCountry) {
      return Object.values(targetCountry).some((item) => {
        return item;
      });
    },
  },
};
export default Student;
